var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BottomAxis"},[_c('p',[_vm._v("朝九晚四 (广州)网络科技有限公司")]),_c('p',[_vm._v("粤ICP备2021090037号-1")])])
}]

export { render, staticRenderFns }